__turbopack_context__.v({
  "className": "poiret_one_c9fd4203-module__6IRV3G__className",
});
